module.exports = __webpack_public_path__ + "static/media/left-arrow.b5bea0a7.svg";